import { Button, Card, Text, VSpacer } from '@/components/DesignSystem';
import { PointsTag } from '@/components/shared/PointsTag';
import { ApiPromotion } from '@api/interfaces';
import { useTheme } from '@mui/material';
import { Stack } from '@mui/system';
import { getJsDateFromString } from '@shared/utilities';
import { useTranslation } from 'react-i18next';


interface PromotionCardProps {
  onClickDetails: () => void,
  promotion: ApiPromotion,
}

export const PromotionCard = ({
  onClickDetails,
  promotion,
}: PromotionCardProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Card testID={`promotion-card-${promotion.id}`}>
      {!!promotion.manufacturer?.name && (
        <>
          <Text category="overline" sx={{ color: theme.palette.text.secondary }}>
            {promotion.manufacturer.name.toUpperCase()} {t($ => $.products.promotionCard.label)}
          </Text>
          <VSpacer size="1" />
        </>
      )}
      <Text fontSize="20px" fontWeight={500}>
        {promotion.name}
      </Text>
      <VSpacer size="3" />
      <PointsTag
        labelStyle={{ color: 'black' }}
        points={promotion.value}
        rewardsType={promotion.rewardType}
        variant="filled"
      />
      <VSpacer size="2" />
      <Stack alignItems="flex-end" direction="row" justifyContent="space-between">
        <Text sx={{ color: theme.palette.text.secondary }}>
          {t(
            $ => $.products.promotionCard.expires,
            { date: getJsDateFromString(promotion.endDate) },
          )}
        </Text>
        <Button
          onClick={onClickDetails}
          sx={{ width: "102px" }}
          testID="details-button"
          variant="outlined"
        >
          {t($ => $.common.actions.details)}
        </Button>
      </Stack>
    </Card>
  );
};
